import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import {
  ArrowLeft,
  ArrowRight,
  Bell,
  Briefcase,
  CheckCircle,
  Search,
  Image,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  CircleCheckBig,
  CirclePlus,
  CloudUpload,
  CreditCard,
  FileText,
  House,
  LogOut,
  LucideAngularModule,
  Mail,
  Menu,
  MoreVertical,
  Pencil,
  Plus,
  SendHorizontal,
  Star,
  StepForward,
  SubscriptIcon,
  Trash2,
  TriangleAlert,
  Upload,
  User,
  UserCheck,
  X,
  Zap,
  CircleX,
  Info,
  EyeClosed,
  Eye,
  Paperclip,
  Mic,
  Camera,
  MapPin,
  Video,
  Headphones,
  Play,
  Pause,
  Check,
  LocateFixed,
  Phone,
  CornerUpLeft,
  Copy,
  MessageSquare,
  Ban,
  CircleAlert,
  Download,
  ChevronUp,
  EllipsisVertical,
  Trash,
  Minus,
  AlertCircle,
  Bookmark,
  MessageSquareText,
  Link2,
  Settings,
  CalendarDays,
  PhoneCall,
  Clock,
  MessageSquareX,
  RefreshCcw,
  Reply,
  MessageCircle,
  LockKeyhole,
} from 'lucide-angular';
import { NgStepperModule } from 'angular-ng-stepper';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { RouterOutlet } from '@angular/router';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import {
  ImageCropperComponent,
  ImageCroppedEvent,
  LoadedImage,
} from 'ngx-image-cropper';
import {
  NgxScannerQrcodeComponent,
  NgxScannerQrcodeModule,
} from 'ngx-scanner-qrcode';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxScannerQrcodeModule,
    NgxIntlTelInputModule,
    NgbPopoverModule,
    NgxMaterialTimepickerModule,
    LucideAngularModule.pick({
      Mail,
      House,
      FileText,
      Bell,
      TriangleAlert,
      CircleCheckBig,
      Ban,
      CircleAlert,
      Clock,
      Menu,
      Camera,
      Zap,
      CircleX,
      Info,
      MoreVertical,
      Pencil,
      ChevronRight,
      ChevronLeft,
      UserCheck,
      LogOut,
      User,
      Upload,
      CloudUpload,
      Trash2,
      Briefcase,
      StepForward,
      Plus,
      X,
      AlertCircle,
      ArrowRight,
      ArrowLeft,
      CreditCard,
      Pause,
      Settings,
      Check,
      MessageSquareX,
      CalendarDays,
      PhoneCall,
      Link2,
      Search,
      Bookmark,
      MessageSquareText,
      Minus,
      ChevronDown,
      ChevronUp,
      EllipsisVertical,
      Trash,
      Download,
      LocateFixed,
      MessageSquare,
      CornerUpLeft,
      Copy,
      Phone,
      CheckCircle,
      Paperclip,
      Headphones,
      Mic,
      Play,
      MapPin,
      Video,
      SubscriptIcon,
      Star,
      CirclePlus,
      Eye,
      EyeClosed,
      SendHorizontal,
      Reply,
      MessageCircle,
      Image,
      RefreshCcw,
      LockKeyhole
    }),
    LucideAngularModule,
    NgStepperModule,
    CdkStepperModule,
    NgxChartsModule,
    BsDropdownModule,
    TabsModule,
    CarouselModule.forRoot(),
    RouterOutlet,
    ImageCropperComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxIntlTelInputModule,
    NgxMaterialTimepickerModule,
    NgbPopoverModule,
    LucideAngularModule,
    NgStepperModule,
    CdkStepperModule,
    NgxChartsModule,
    BsDropdownModule,
    TabsModule,
    CarouselModule,
    RouterOutlet,
  ],
})
export class SharedModule {}
